import { ODataObject } from '../../interfaces/odata-model.interface';
import {
    JsonNumberModelOptions,
    NumberModelOptions,
    NumberModelOptionsFromJson,
} from '../options/number-model-options';
import { PrimitiveModel } from './primitive.model';

export class NumberModel extends PrimitiveModel {
    public constructor(
        name: string,
        public value: number | undefined,
        public options = new NumberModelOptions(),
    ) {
        super(name, value, options);
    }

    /**
     * Increase the value in this NumberModel
     *
     * @param {number} [amount]
     * @returns {boolean}
     */
    public inc(amount = 1): boolean {
        const newValue = this.value ? this.value + amount : 1;
        if (newValue > this.options.maxValue) {
            return false;
        }

        this.value = newValue;

        return true;
    }

    /**
     * Decrease the value in this number
     *
     * @param {number} [amount] the amount to decrease; defaults to 1
     * @returns {boolean} if decreasing was successful
     */
    public dec(amount = 1): boolean {
        const newValue = this.value ? this.value - amount : -1;
        if (newValue < this.options.minValue) {
            return false;
        }

        this.value = newValue;

        return true;
    }

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     *
     * @returns {object} an object with 'name' as key and the value as value
     */
    public getOutModel(): ODataNumberOutModel {
        const outModel: ODataNumberOutModel = {};

        outModel[this.name] = typeof this.value === 'undefined' ? null : this.value;

        return outModel;
    }
}

export class NumberModelFromJson extends NumberModel {
    public constructor(data: JsonNumberModel) {
        super(data.name, data.value, new NumberModelOptionsFromJson(data.options));
    }
}

export interface JsonNumberModel {
    name: string;
    value: number;
    options: JsonNumberModelOptions;
}

export interface ODataNumberOutModel extends ODataObject {
    [key: string]: number | null;
}
